import { getBrowserLanguage } from "$routes/_lib/use-user-language";
import { useEffect, useState } from "react";
import getPolyfills from "./get-polyfills";

export default function useLoadPolyfillsEffect() {
  const [polyfillsLoaded, setPolyfillsLoaded] = useState(false);

  useEffect(() => {
    const browserLanguage = getBrowserLanguage();
    Promise.all(getPolyfills(browserLanguage))
      .catch((error) => {
        console.warn("Failed fetching polyfills", { error });
      })
      .finally(() => {
        setPolyfillsLoaded(true);
      });
  }, []);
  return polyfillsLoaded;
}
